export const getAdvancedSearchStyles = () => {
  return {
    ".advanced-search-select-container": {
      position: "relative",
      ":after": {
        content: "''",
        position: "absolute",
        bottom: -4,
        left: -31,
        width: "calc(70% + 24px)",
        height: 2,
        backgroundColor: "#1095F9",
        WebkitClipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
        clipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
        "@media only screen and (max-width: 600px)": {
          bottom: -4,
          left: -31,
          height: 2,
        },
      },
      ".advanced-search-select__control": {
        border: "none",
        backgroundColor: "transparent",
        "&.advanced-search-select__control--is-focused": {
          boxShadow: "0 0 0 1px transparent",
        },
        "&.advanced-search-select__control--menu-is-open svg": {
          transform: "rotate(180deg)",
        },
        ".advanced-search-select__value-container": {
          padding: "0",
          ".advanced-search-select__placeholder": {
            fontFamily: "Manrope ",
            fontSize: "1.125rem ",
            lineHeight: "1.625rem ",
            fontWeight: 700,
            marginRight: 8,
            textAlign: "left",
            letterSpacing: "0.02em",
            color: "#C0C0C0",
            "@media only screen and (max-width: 600px)": {
              fontFamily: "Manrope ",
              fontSize: "1.125rem ",
              lineHeight: "1.625rem ",
              fontWeight: 700,
              marginRight: 8,
              textAlign: "left",
              letterSpacing: "0.02em",
              color: "#C0C0C0",
            },
          },
          ".advanced-search-select__single-value": {
            color: "#1D3140",
            fontFamily: "Manrope ",
            fontSize: "1.125rem ",
            lineHeight: "1.625rem ",
            fontWeight: 700,
            marginRight: 8,

            "@media only screen and (max-width: 600px)": {
              color: "#1D3140",
              fontFamily: "Manrope ",
              fontSize: "1.125rem ",
              lineHeight: "1.625rem ",
              fontWeight: 700,
              marginRight: 8,
            },
          },
          ".advanced-search-select__input-container ": {},
        },
        ".advanced-search-select__indicators": {
          ".advanced-search-select__indicator-separator": {
            display: "none",
          },
          ".advanced-search-select__indicator ": {
            padding: "0",
            svg: {
              color: "#27509B",
              height: 30,
              width: 30,
              transition: "all 0.5s",
              "@media only screen and (max-width: 600px)": {
                height: 25,
                width: 25,
              },
            },
          },
        },
      },
      ".advanced-search-select__menu": {
        minWidth: "254px",
        marginTop: 8,
        left: "-40px",
        borderRadius: "24px",
        ".advanced-search-select__menu-list": {
          marginRight: "12px",
          scrollbarColor: "red",
          marginTop: "12px",
          marginBottom: "10px",
          ".advanced-search-select__option": {
            fontFamily: "Manrope",
            fontSize: "1.125rem",
            fontWeight: 700,
            lineHeight: "1.875rem",
            color: "#1D3140",
            padding: "12px 24px",
            "&.advanced-search-select__option--is-focused": {
              backgroundColor: "#FFFFFF",
              color: "#27509B",
            },
            "&.advanced-search-select__option--is-selected": {
              backgroundColor: "#FFFFFF",
              color: "#27509B",
            },
          },
          "::-webkit-scrollbar": {
            width: "3px",
            height: "3px",
            backgroundColor: "transparent",
          },
          "::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
          "::-webkit-scrollbar-track-piece": {
            backgroundColor: "#C0C0C0",
          },
          "::-webkit-scrollbar-thumb": {
            backgroundColor: "#000",
            borderRadius: "10px",
            border: "none",
          },
          "::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#555",
          },
          "::-webkit-scrollbar-corner": {
            backgroundColor: "transparent",
          },
        },
      },
    },
  };
};
